module.exports = __webpack_public_path__ + "img/red-3-squiggly-open.ed247516.svg";